import { render, staticRenderFns } from "./QHqBirthdaysDrilldown.vue?vue&type=template&id=18044c54&scoped=true&"
import script from "./QHqBirthdaysDrilldown.vue?vue&type=script&lang=js&"
export * from "./QHqBirthdaysDrilldown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18044c54",
  null
  
)

export default component.exports